import components from "./components.js";
import pages from "./pages/index.js";
import wlps from "./wlps.js";

export default {
  apply: "Applica",
  asOf: (ctx) => `al ${ctx.named("date")}`,
  cancel: "Annulla",
  contactUs: "Contattaci",
  edit: "Modifica",
  error: "Errore",
  from: "Da",
  ok: "Ok",
  loading: "Caricamento...",
  logIn: "Accedi",
  logOut: "Esci",
  no: "No",
  others: "Altri",
  register: "Registrati",
  save: "Salva",
  saving: "Salvataggio...",
  serverError:
    "Si è verificato un errore nel nostro server. Una segnalazione è stata inviata al nostro team e risolveremo il problema il prima possibile. Non esitare a contattarci se il problema persiste.",
  success: "Operazione riuscita",
  to: "A",
  warning: "Attenzione",
  yes: "Sì",
  investorProfileTypes: {
    institutional: "Investitore istituzionale",
    professional: "Investitore professionale",
    retail: "Investitore al dettaglio",
  },
  layouts: {
    main: {
      admin: {
        listUsers: "Elenco utenti",
        platformSettings: "Impostazioni piattaforma",
        products: "Prodotti",
        sectionName: "Amministrazione",
        holdingDataAdjustments: {
          name: "Regolazione dati posizioni",
          categorise: {
            name: "Categorizza",
          },
          translate: {
            name: "Traduci",
          },
          override: {
            name: "Sovrascrivi",
          },
        },
        operations: {
          name: "Operazioni",
          bulkPriceDataUpdate: {
            name: "Aggiorna dati prezzi",
          },
          generateReports: {
            name: "Genera report",
          },
          bulkComponentsUpdate: {
            name: "Importa componenti generici",
          },
          exports: {
            name: "Esportazioni",
          },
        },
      },
      help: {
        contact: "Contatti",
        faq: "FAQ",
        knowledgeBase: "Knowledge Base",
        sectionName: "Aiuto",
      },
      investmentProposal: {
        sectionName: "Proposta di investimento",
        reportGenerationSubSectionName: "Generazione report",
        weightOptimizationSubSectionName: "Ottimizzazione dei pesi",
      },
      products: {
        analysis: "Analisi",
        documents: "Documenti",
        factsheet: "Factsheet",
        overview: "Panoramica",
        sectionName: "Prodotti",
        useCase: "Caso d'uso",
      },
    },
    fullPage: {
      backHome: "Torna alla Home",
    },
    navbar: {
      openInVue3: "Passa alla nuova versione",
    },
    profileDropDown: {
      settings: "Impostazioni",
      dialog: {
        adminAsRegularOnMobile: {
          text: "Le funzionalità amministrative non sono accessibili su dispositivi mobili. Per sfruttare appieno la piattaforma, si prega di utilizzare un computer desktop. Le funzionalità di amministrazione disabilitate includono (ma non sono limitate a): modifica degli elementi nella Panoramica, modifica di un report, caricamento o eliminazione di documenti e accesso alla sezione di amministrazione.",
          title: "Computer desktop richiesto per funzionalità admin",
        },
      },
    },
    theFooter: {
      allRightReserved: "Tutti i diritti riservati",
      copyright: "Copyright",
      ombudsman: "Ombudsman",
      privacyPolicy: "Politica sulla privacy",
      termsOfUse: "Termini di utilizzo",
    },
    verticalNavMenu: {
      closeMenuTextWhenEmbedded: "Chiudi",
      errorLoading: "Errore durante il caricamento del menu",
      openMenuTextWhenEmbedded: "Mostra tutti i fondi",
    },
    verticalNavMenuGroup: {
      search: "Cerca",
      showMore: "Mostra altro",
    },
  },
  perfStats: {
    alpha: "Alfa",
    annualizedReturn: "Rendimento annualizzato",
    annualizedVolatility: "Volatilità annualizzata",
    annualizedVolatilityDaily: "Volatilità annualizzata (giornaliera)",
    averageMonthlyReturns: "Rendimenti mensili medi",
    averageNegativeMonthlyReturns: "Rendimenti mensili negativi medi",
    averagePositiveMonthlyReturns: "Rendimenti mensili positivi medi",
    beta: "Beta",
    calmarRatio: "Indice di Calmar",
    painRatio: "Pain ratio",
    painIndex: "Pain index",
    correlation: "Correlazione",
    cumulativeReturn: "Rendimento cumulativo",
    informationRatio: "Information ratio residuo",
    activeInformationRatio: "Information ratio attivo",
    kurtosis: "Curtosi",
    m2RiskAdjustedPerfMonthly: "Misura M2",
    maxDaysUnderwater: "Max giorni underwater",
    maxMonthsUnderwater: "Max mesi underwater",
    maxConsecutiveNegativeMonthlyReturns: "Max rendimenti mensili negativi consecutivi",
    maxConsecutivePositiveMonthlyReturns: "Max rendimenti mensili positivi consecutivi",
    maxNegativeMonthlyReturn: "Max rendimento mensile negativo",
    maxPositiveMonthlyReturn: "Max rendimento mensile positivo",
    maximumDrawdown: "Drawdown massimo",
    maximum: "Massimo",
    minimum: "Minimo",
    omegaRatio: "Indice Omega",
    ratioOfNegativeMonthlyReturns: "Rapporto rendimenti mensili negativi",
    ratioOfPositiveMonthlyReturns: "Rapporto rendimenti mensili positivi",
    returnToVolatilityRatio: "Rapporto rendimento/volatilità",
    sharpeRatio: "Indice di Sharpe",
    skewness: "Asimmetria",
    sortinoRatio: "Indice di Sortino",
    trackingError: "Tracking error",
    treynorRatio: "Indice di Treynor",
    valueAtRiskOnePercentOneMonth: "Value at Risk (VaR) 1% su 1 mese",
    valueAtRiskFivePercentOneMonth: "Value at Risk (VaR) 5% su 1 mese",
    valueAtRiskOnePercentTwoWeeks: "Value at Risk (VaR) 1% su 2 settimane",
    valueAtRiskFivePercentTwoWeeks: "Value at Risk (VaR) 5% su 2 settimane",
    valueAtRiskOnePercentOneDay: "Value at Risk (VaR) 1% su 1 giorno",
    valueAtRiskFivePercentOneDay: "Value at Risk (VaR) 5% su 1 giorno",
  },
  validations: {
    afterDate: (ctx) =>
      ctx.named("nDaysApart") == 0
        ? `La data deve essere successiva al ${ctx.named("minDate")} (incluso)`
        : `La data deve essere almeno ${ctx.named("nDaysApart")} giorni dopo il ${ctx.named("minDate")}`,
    beforeDate: (ctx) =>
      ctx.named("nDaysApart") == 0
        ? `La data deve essere prima del ${ctx.named("maxDate")} (incluso)`
        : `La data deve essere almeno ${ctx.named("nDaysApart")} giorni prima del ${ctx.named("maxDate")}`,
    confirmed: "Il campo non corrisponde a quello precedente.",
    dateFormat: "La data deve essere nel formato AAAA-MM-GG.",
    email: "L'email non è valida.",
    maxFileSize: (ctx) =>
      `Il file è più grande della dimensione massima autorizzata (${ctx.named(
        "maxSizeMegabytes"
      )} MB).`,
    maxChar: (ctx) => `Il campo non può avere più di ${ctx.named("length")} caratteri.`,
    minChar: (ctx) => `Il campo necessita di almeno ${ctx.named("length")} caratteri.`,
    minValue: (ctx) => `Il valore deve essere maggiore o uguale a ${ctx.named("min")}.`,
    phoneNumber: "Questo campo non è un numero di telefono valido.",
    required: "Questo campo è obbligatorio.",
    roleFormat: 'Il nome del ruolo non può contenere il carattere ":".',
    forbiddenRoleName: "Questo nome di ruolo è riservato.",
    sum: (ctx) =>
      `La somma prevista è ${ctx.named("expectedValue")} (attuale: ${ctx.named("currentValue")}).`,
  },
  wlps,
  pages,
  components,
};
